import { render } from "./ToolbarSeparator.vue?vue&type=template&id=51308bbc&scoped=true"
const script = {}

import "./ToolbarSeparator.vue?vue&type=style&index=0&id=51308bbc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51308bbc"]])

export default __exports__